import _ from "lodash"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"
import {useRef} from "react"
import {debounce} from "../../../anwendungskonfigurator/misc/utils"

export const BetriebsunterbrechungActions = ({
    loadCurrentLocationData,
    getDataFromPointer,
    navigate,
    sendDataToBackend,
    updateData,
}) => {
    const ecSendDataRef = useRef()

    if (!ecSendDataRef.current) {
        ecSendDataRef.current = _.debounce(sendDataToBackend, 500)
    }

    const feuerSendDataRef = useRef()

    if (!feuerSendDataRef.current) {
        feuerSendDataRef.current = _.debounce(sendDataToBackend, 500)
    }

    return {
        INIT_BU: () => {
            loadCurrentLocationData("/betriebsunterbrechung")
        },
        UPDATE_BU_EC: () => {
            const versicherungssummeEC = getDataFromPointer(
                "/betriebsunterbrechung/versicherungssummeEC",
            )
            if (versicherungssummeEC) {
                ecSendDataRef.current(
                    versicherungssummeEC._links.versicherungssummeBuUpdate,
                    versicherungssummeEC,
                    "/betriebsunterbrechung/versicherungssummeEC",
                    (x) => x,
                    updateData,
                    getDataFromPointer,
                )
            }
        },
        UPDATE_BU_Feuer: () => {
            const versicherungssummeFeuer = getDataFromPointer(
                "/betriebsunterbrechung/versicherungssummeFeuer",
            )
            if (versicherungssummeFeuer) {
                feuerSendDataRef.current(
                    versicherungssummeFeuer._links.versicherungssummeBuUpdate,
                    versicherungssummeFeuer,
                    "/betriebsunterbrechung/versicherungssummeFeuer",
                    (x) => x,
                    updateData,
                    getDataFromPointer,
                )
            }
        },
        UWP_WEITER: () => {
            navigate(pathBuilder(getDataFromPointer("/links/page:forward")))
        },
    }
}
